<template>
    <div>
        <div class="card overflow-auto">
            <div class="card-body">
                <div class="row justify-content-around">
                    <select v-model="type" @change="setDate()" class="form-control col-12 col-lg-3">
                        <option value="date">Số liệu của 1 ngày</option>
                        <option value="month">Số liệu của 1 tháng</option>
                        <option value="months">Số liệu của nhiều tháng</option>
                    </select>

                    <div v-if="type == 'months'" class="row col-12 col-lg-3 px-lg-3" style="padding: 0;">
                        <input v-model="from" type="month" class="col form-control" />
                        <div class="col-12 col-lg-2">To</div>
                    </div>

                    <input v-model="date" :type="type == 'date' ? 'date' : 'month'" class="form-control col-12 col-lg-3" />

                    <div class="col-12 col-lg-3 text-center">
                        <button @click="find()" :disabled="isLoading" class="btn btn-primary">Tìm</button>
                    </div>
                </div>
            </div>

            <div v-if="isLoading" class="text-center">{{ loadingText }}</div>
            <div v-else class="mx-2">
                <h3>Lô</h3>
                <div v-for="(count, number) in result['lo']" :key="'lo-' + number">
                    <div :style="{ 
                            width: count * 50 + 'px', 
                            borderRadius: '0px 8px 8px 0px',
                            background: (count < avg / 2) ? 'lightgreen' : (count < avg) ? '#62f6e8' : (count < avg /2 * 3) ? '#ecba4d' : '#f66276',
                        }"
                    >
                        <span class="bg-light">{{ number }}</span> | {{ count }}
                    </div>
                </div>
                <div>NX: Trong lô, 1 số xuất hiện trung bình 7.8 lần 1 tháng.</div>
                
                <h3>Đề</h3>
                <div v-for="(count, number) in result['de']" :key="'de-' + number">
                    <div :style="{ border: '1px solid', width: count * 50 + 'px' }">{{ number }} | {{ count }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { backendApi } from '@/api/constant.js'

export default {
    data(){
        return {
            type: 'date',
            from: null,
            date: null,
            static: [],
            result: {},
            isLoading: false,
            host: '',
            loadingText: 'Loading.',
            avg: 1000,
        }
    },
    methods:{
        async find(){
            if(!this.date) return alert('Chưa chọn ngày tháng.');
            let to = this.date.split('-');
            let month = [1];
            if(this.type != 'months'){
                this.avg = 7.8; 
                this.isLoading = this.runLoadingScreen();
                let dateArr = this.date.split('-')
                let dateString = `?year=${dateArr[0]}&month=${dateArr[1]}&date=${dateArr[2]}`
                let response = { data: {} }
                try{
                    response = await this.getStatic(dateString);
                } catch(e) {
                    console.error(e)
                    clearInterval(this.isLoading);
                    this.isLoading = false;
                    this.$toast.error("Error!");
                }
                clearInterval(this.isLoading);
                this.isLoading = false;
                this.result = response.data;
                
                if(this.type == 'month' && !this.static[month]){
                    this.static[month] = this.result;
                }
                return;
            }
            if(!this.from) return alert('Chưa chọn ngày tháng.');
            let from = this.from.split('-');
            let time = parseInt(to[0]*12 + 1*to[1]) - parseInt(from[0]*12 + 1*from[1]);
            if(time <= 0) return alert('Khoảng thời gian không hợp lệ.');
            if(time > 6) return alert('Quá nhiều dữ liệu. Xin đừng bắt tôi xử lý hết chừng ấy dữ liệu.');
            this.avg = time * 30 * 26 / 100;

            this.isLoading = this.runLoadingScreen();
            try {
                if(from[0] == to[0]){
                    for(let i = 1*from[1]; i <= to[1]; i++){
                        await this.getMonthStatic(i, to[0]);
                    }
                } else {
                    for(let i = 1*from[1]; i <= 12; i++){
                        await this.getMonthStatic(i, from[0]);
                    }
                    for(let i = 1; i <= to[1]; i++){
                        await this.getMonthStatic(i, to[0]);
                    }
                }
            } catch(e) {
                console.error(e)
                clearInterval(this.isLoading);
                this.isLoading = false;
                this.$toast.error("Error!");
            }
            clearInterval(this.isLoading);
            this.isLoading = false;

            this.result['de'] = {};
            this.result['lo'] = {};
            for(let index in this.static){
                let s = this.static[index];
                for(let deIndex in s['de']){
                    if(!this.result['de'][deIndex]) this.result['de'][deIndex] = 0;
                    this.result['de'][deIndex] += s['de'][deIndex];
                }
                for(let loIndex in s['lo']){
                    if(!this.result['lo'][loIndex]) this.result['lo'][loIndex] = 0;
                    this.result['lo'][loIndex] += s['lo'][loIndex];
                }
            }
        },
        async getMonthStatic(month, year){
            let index = month;
            if(index < 10) index = '0'+month;
            if(!this.static[index]) this.static[index] = (await this.getStatic(`?year=${year}&month=${index}`)).data;
        },
        getStatic(dateString){
            return this.$axios.get(this.host + '/api/lotto' + dateString);
        },
        setDate(){
            this.avg = 1000;
            let d = new Date();
            let month = d.getMonth()+1;
            if(month < 10) month = '0' + month;
            let date = d.getDate();
            if(date < 10) date = '0' + date;

            if(this.type == 'date') return this.date = `${d.getFullYear()}-${month}-${date}`;

            if(this.type == 'month') return this.date = `${d.getFullYear()}-${month}`;

            return this.date = ''+d.getFullYear();
        },
        runLoadingScreen(){
            const text = [
                'Loading..',
                'Loading...',
                'Fetching yesterday data...',
                'Training the AI...',
                'Flirting with your sister...',
                'Done',
                'In a few second...',
                'How is your mom lately?',
            ];
            let i = 0;
            return setInterval(() => {
                if(i >= 8) i -= 8;
                this.loadingText = text[i++];
            }, 1000);
        }
    },
    created(){
        this.setDate();
        this.host = backendApi.url
    }
}
</script>

<style>

</style>